import type { Tag, TagAlias } from '@/api'
import { matchText } from './fuzzy'

// The tags a search keeps, best match first. The name ranks before an alias at the same tier (a tier is how `matchText`
// matched: prefix, somewhere, letters in order); ties and an empty search keep the order of `tags`.
export function searchTags(tags: Tag[], query: string): Tag[] {
  const needle = query.trim().toLowerCase()
  if (!needle) return tags
  const ranked: { tag: Tag; rank: number; index: number }[] = []
  tags.forEach((tag, index) => {
    const ranks = [
      matchText(tag.name, needle)?.tier,
      ...tag.aliases.map((alias) => {
        const tier = matchText(alias.alias, needle)?.tier
        return tier === undefined ? undefined : tier + 0.5
      }),
    ].filter((rank): rank is number => rank !== undefined)
    if (ranks.length) ranked.push({ tag, rank: Math.min(...ranks), index })
  })
  ranked.sort((a, b) => a.rank - b.rank || a.index - b.index)
  return ranked.map((entry) => entry.tag)
}

// The aliases a search keeps, best match first (prefix, somewhere, letters in order); ties and an empty search keep the
// order of `aliases`.
export function searchAliases(aliases: TagAlias[], query: string): TagAlias[] {
  const needle = query.trim().toLowerCase()
  if (!needle) return aliases
  const ranked: { alias: TagAlias; tier: number; index: number }[] = []
  aliases.forEach((alias, index) => {
    const tier = matchText(alias.alias, needle)?.tier
    if (tier !== undefined) ranked.push({ alias, tier, index })
  })
  ranked.sort((a, b) => a.tier - b.tier || a.index - b.index)
  return ranked.map((entry) => entry.alias)
}
